import { Component, Input } from '@angular/core';
import { IframeEmbedService } from '../../../@core/services/iframe-embed.service';

/**
 * Iframe embed: Upshop mark loader. Standalone: animated cart (legacy).
 * Use wherever `sk-animated-cart-spinner` was used for loading chrome.
 */
@Component({
	selector: 'sk-iframe-embed-loading',
	templateUrl: './iframe-embed-loading.component.html',
	styleUrls: ['./iframe-embed-loading.component.scss'],
})
export class IframeEmbedLoadingComponent {
	@Input() scale = 1;

	constructor(public iframeEmbed: IframeEmbedService) {}

	get compactUpshop(): boolean {
		return this.scale <= 1;
	}
}
